module.exports = __webpack_public_path__ + "img/instagram.d877a41b.jpeg";